module.exports = __webpack_public_path__ + "img/analytics_average.b15146ef.png";